import { TIMEPICKER_ROLE } from '@wix/wix-data-client-common-standalone'

import { type TimePickerData } from '../types'
import {
  assertNonNullable,
  assertTimePickerData,
  setConnectionConfigPropertyField,
} from '../utils'
import { addComponentForField } from './addComponentForField'
import { type FieldComponentAdder } from './types'

export const addComponentForTimeField: FieldComponentAdder = ({
  fieldKey,
  fieldName,
  page,
  templateComponentByVeloId,
  templateControllerConnectionsByVeloId,
}) =>
  addComponentForField({
    page,
    templateComponentByVeloId,
    templateControllerConnectionsByVeloId,
    templateVeloId: 'timeFieldTemplate',
    componentAdjustments: {
      modifyComponent: component => {
        assertNonNullable(component.data)
        assertTimePickerData(component.data)
        const data: TimePickerData = { ...component.data, label: fieldName }
        return { ...component, data }
      },
      connectionConfigModifierByRole: {
        [TIMEPICKER_ROLE]: config =>
          setConnectionConfigPropertyField({
            config,
            propertyName: 'value',
            fieldKey,
          }),
      },
      veloId: `${fieldKey}Field`,
    },
  })
